import { Link } from "react-router-dom";

export enum RideStatus {
  ongoing = "ongoing",
  canceled = "canceled",
  completed = "completed",
  scheduled = "scheduled",
}

interface Stops {
  location: string;
}

interface HistoryRecordProps {
  status: RideStatus;
  time: string;
  fromLocation: string;
  date: string;
  stops: Stops[];
}
export default function HistoryRecord({
  status,
  time,
  fromLocation,
  date,
  stops,
}: HistoryRecordProps) {
  let statusStyle = "bg-[#E9F4FF] text-[#0076E2]";
  if (status === RideStatus.canceled) {
    statusStyle = "bg-error/10 text-error";
  } else if (status === RideStatus.scheduled) {
    statusStyle = "bg-[#FFF5DB] text-[#D07D00]";
  } else if (status === RideStatus.completed) {
    statusStyle = "bg-success/10 text-success";
  }
  return (
    <div className="max-lg:relative border border-border/50 rounded-[10px] p-5 lg:flex items-center justify-between my-5">
      <div className="max-lg:mb-5 w-full lg:w-[60%]">
        <h1 className="font-medium text-xl mb-2 max-lg:mb-4">{fromLocation}</h1>
        <div className="flex space-x-2">
          <div className="text-center my-3">
            <h1>From</h1>
            {stops.length > 1 ? (
              stops.map((stop, index) => (
                <div key={index}>
                  <div className="h-5 bg-themeText w-[2px] mx-auto"></div>
                  <h1>To</h1>
                </div>
              ))
            ) : (
              <div>
                <div className="h-5 bg-themeText w-[2px] mx-auto"></div>
                <h1>To</h1>
              </div>
            )}
          </div>
          <div className="bg-border p-3 bg-opacity-[0.1] rounded-[10px] w-full">
            <h1 className="text-paragraph font-medium mb-2 mt-1">
              {fromLocation}
            </h1>
            {stops.map((stop, index) => (
              <div
                key={index}
                className="relative flex items-center justify-between space-x-5"
              >
                <h1 className="my-2 text-paragraph font-medium">
                  {stop.location}
                </h1>
                {stops.length > 1 && (
                  <div>
                    <div className="bg-accent w-[6px] h-[6px] flex items-center justify-center p-4 rounded-full">
                      <h1 className="font-medium">{index}</h1>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="lg:relative max-lg:flex items-center justify-between">
        <div className={`${statusStyle} rounded-lg py-1 px-7 w-fit`}>
          <h1 className="text-lg font-semibold capitalize">{status}</h1>
        </div>
        <div>
          <h2 className="text-themeGray font-medium text-right text-sm mt-2">
            {date} {time}
          </h2>
          {status === RideStatus.completed && (
            <Link
              to="/delivery-details"
              className="max-lg:top-1 max-lg:right-5 py-1 rounded-lg bg-border/50 text-themeGray cursor-pointer w-fit text-sm px-3 absolute right-0 mt-3"
            >
              <h1 className="font-medium">View details</h1>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
